import "../proposal.css";
import { useProposalT } from "../i18n/ProposalI18nContext";

export function NetworkSection() {
  const { t } = useProposalT();

  const stats = [
    {
      value: "+3.000",
      label: t("network.stat.flexibleOffices"),
      yellow: false,
    },
    { value: "+4.200", label: t("network.stat.meetingRooms"), yellow: false },
    { value: "+1.000", label: t("network.stat.eventSpaces"), yellow: false },
    { value: "+400", label: t("network.stat.cities"), yellow: true },
  ];

  const spaceTypes = [
    {
      img: "https://d1y4va1nna2r1p.cloudfront.net/spaces/9fe79f80-22f8-4d17-a581-de43824dd42b.png",
      title: t("network.type.workstations"),
      badgeBg: "#D4EDDA",
      descPre: t("network.type.workstationsDescPre"),
      descBold: t("network.type.workstationsDescCount"),
      descPost: t("network.type.workstationsDescPost"),
      credits: "1–2",
      creditsLabel: t("network.credits"),
    },
    {
      img: "https://d1y4va1nna2r1p.cloudfront.net/spaces/0e55d317-8353-4d63-9095-22b77e9d0ef4.png",
      title: t("network.type.meetingRooms"),
      badgeBg: "#CCE5FF",
      descPre: t("network.type.meetingRoomsDescPre"),
      descBold: t("network.type.meetingRoomsDescCount"),
      descPost: t("network.type.meetingRoomsDescPost"),
      credits: "1–3",
      creditsLabel: t("network.credits"),
    },
    {
      img: "https://d1y4va1nna2r1p.cloudfront.net/spaces/a9a7735d-6146-4253-9ddc-ac59f577b735.png",
      title: t("network.type.eventSpaces"),
      badgeBg: "#FFE0B2",
      descPre: t("network.type.eventSpacesDescPre"),
      descBold: t("network.type.eventSpacesDescCount"),
      descPost: t("network.type.eventSpacesDescPost"),
      credits: "1–3",
      creditsLabel: t("network.creditsPerPerson"),
    },
    {
      img: "https://d1y4va1nna2r1p.cloudfront.net/spaces/be722dee-abe4-4e27-aa1a-e6669fd689d9.png",
      title: t("network.type.privateOffices"),
      badgeBg: "#F8D7DA",
      descPre: t("network.type.privateOfficesDescPre"),
      descBold: t("network.type.privateOfficesDescCount"),
      descPost: t("network.type.privateOfficesDescPost"),
      credits: "10–15",
      creditsLabel: t("network.creditsPerPosition"),
    },
  ];

  return (
    <section
      id="rede-woba"
      className="py-20 px-6 font-space-grotesk"
      style={{ background: "#FDFBF7", borderTop: "1px solid #E8E6E3" }}
    >
      <div style={{ maxWidth: "64rem", margin: "0 auto" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "48px" }}>
          <span
            style={{
              display: "inline-block",
              padding: "6px 16px",
              borderRadius: "999px",
              fontSize: "13px",
              fontWeight: 600,
              color: "#1A1814",
              border: "1px solid #E8E6E3",
              background: "white",
              marginBottom: "12px",
              letterSpacing: "0.03em",
            }}
          >
            {t("network.badge")}
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: "#1A1814" }}
          >
            {t("network.heading")
              .split("\n")
              .map((line, i, arr) => (
                <span key={i}>
                  {line}
                  {i < arr.length - 1 && <br />}
                </span>
              ))}
          </h2>
          <p
            className="text-base"
            style={{
              color: "#78736D",
              maxWidth: "580px",
              margin: "0 auto",
              lineHeight: 1.7,
            }}
          >
            {t("network.subheading")}
          </p>
        </div>

        {/* Stats Grid */}
        <div
          className="grid grid-cols-2 md:grid-cols-4"
          style={{ gap: "16px", marginBottom: "48px" }}
        >
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="p-4 md:p-6"
              style={{
                background: "white",
                border: "1px solid #E8E6E3",
                borderRadius: "16px",
                textAlign: "center",
              }}
            >
              <span
                className="block text-3xl md:text-4xl"
                style={{
                  fontWeight: 800,
                  color: stat.yellow ? "#FFD900" : "#1A1814",
                  lineHeight: 1,
                  ...(stat.yellow
                    ? { textShadow: "0 1px 2px rgba(0,0,0,0.1)" }
                    : {}),
                  fontFamily: "'Space Grotesk', sans-serif",
                }}
              >
                {stat.value}
              </span>
              <p
                className="text-xs md:text-sm"
                style={{ color: "#78736D", margin: "6px 0 0" }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        {/* 4 Asset Type Cards */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
          style={{ gap: "16px" }}
        >
          {spaceTypes.map((type) => (
            <div
              key={type.title}
              className="space-type-card"
              style={{
                background: "white",
                border: "1px solid #E8E6E3",
                borderRadius: "16px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  height: "140px",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src={type.img}
                  alt={type.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  loading="lazy"
                />
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    background: type.badgeBg,
                    borderRadius: "8px",
                    padding: "4px 10px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      color: "#1A1814",
                    }}
                  >
                    {type.title}
                  </span>
                </div>
              </div>
              <div style={{ padding: "16px 18px" }}>
                <p
                  style={{
                    fontSize: "13px",
                    color: "#78736D",
                    margin: "0 0 12px",
                    lineHeight: 1.5,
                  }}
                >
                  {type.descPre} <strong>{type.descBold}</strong>{" "}
                  {type.descPost}
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "8px 12px",
                    background: "#F5F3EF",
                    borderRadius: "8px",
                  }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#78736D"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M16 8h-6a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8" />
                  </svg>
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: 700,
                      color: "#1A1814",
                    }}
                  >
                    {type.credits}
                  </span>
                  <span style={{ fontSize: "12px", color: "#78736D" }}>
                    {type.creditsLabel}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
